export default {"src":"/_next/static/media/knife-fork.d9c4abe4.svg","height":33,"width":33};